import {type DocumentFieldActionGroup, type DocumentFieldActionItem} from 'sanity'

// TODO: consider adding this to core
export function defineActionItem(node: DocumentFieldActionItem): DocumentFieldActionItem {
  return node
}

// TODO: consider adding this to core
export function defineActionGroup(node: DocumentFieldActionGroup): DocumentFieldActionGroup {
  return node
}
